import Calendar from 'react-calendar';
import { formatInternalDate } from '~/lib/DateTime.js';
import useWeekStart from '~/lib/useWeekStart.js';
import { isSameDay, isToday } from 'date-fns';
import { dateClassNames, FormPart, part } from '~/lib/FormCssApi';

/**
 * react-calendar only hands tiles class names, so the stable date hooks are
 *  classes. We compose them with whatever classes the caller wants, and reuse
 *  the caller's tileDisabled to decide which dates count as unavailable.
 */
function dateTileClassName({ tileClassName, tileDisabled, selectedDate }) {
    return tileProps => {
        const callerClassName = tileClassName ? tileClassName(tileProps) : null;

        // The month view is the one tiling days; year and decade views tile
        //  months and years, which aren't dates a client can pick
        const isDay = tileProps.view === 'month';

        return [
            ...(isDay
                ? dateClassNames({
                      isSelected:
                          !!selectedDate &&
                          isSameDay(tileProps.date, selectedDate),
                      isUnavailable:
                          !!tileDisabled && !!tileDisabled(tileProps),
                      isToday: isToday(tileProps.date),
                  })
                : []),
            ...(Array.isArray(callerClassName)
                ? callerClassName
                : [callerClassName]),
        ].filter(name => !!name);
    };
}

const MonthlyAvailabilityMiniCal = ({
    selectedDate,
    setSelectedDate,
    canSelectAnyDate,

    tileDisabled,
    tileClassName,

    setView,
    viewActiveDate,
    updateActiveStart,
}) => {
    const weekStart = useWeekStart();

    return (
        <div
            {...part(FormPart.CALENDAR)}
            className="availability-picker__calendar inline-block align-top mb-2"
        >
            <Calendar
                onChange={setSelectedDate}
                goToRangeStartOnSelect={false}
                calendarType={weekStart === 0 ? 'gregory' : 'iso8601'}
                value={selectedDate}
                showFixedNumberOfWeeks={true}
                minDate={canSelectAnyDate ? null : new Date()}
                activeStartDate={viewActiveDate}
                onActiveStartDateChange={({
                    action,
                    activeStartDate,
                    value,
                    view,
                }) => {
                    updateActiveStart(activeStartDate);
                    setView(view);
                }}
                tileDisabled={tileDisabled}
                tileClassName={dateTileClassName({
                    tileClassName,
                    tileDisabled,
                    selectedDate,
                })}
            />
        </div>
    );
};

export default MonthlyAvailabilityMiniCal;
